export const GROUP_DELETE = 'GROUP_DELETE'
export const GROUP_DELETE_SUCCESS = 'GROUP_DELETE_SUCCESS'
export const GROUP_DELETE_FAILURE = 'GROUP_DELETE_FAILURE'

export const GROUP_BY_CLIENT = 'GROUP_BY_CLIENT'
export const GROUP_BY_CLIENT_SUCCESS = 'GROUP_BY_CLIENT_SUCCESS'
export const GROUP_BY_CLIENT_FAILURE = 'GROUP_BY_CLIENT_FAILURE'

export const GROUP_BY_CLIENT_USER_ID = 'GROUP_BY_CLIENT_USER_ID'
export const GROUP_BY_CLIENT_USER_ID_SUCCESS = 'GROUP_BY_CLIENT_USER_ID_SUCCESS'
export const GROUP_BY_CLIENT_USER_ID_FAILURE = 'GROUP_BY_CLIENT_USER_ID_FAILURE'

export const GROUP_DETAIL = 'GROUP_DETAIL'
export const GROUP_DETAIL_SUCCESS = 'GROUP_DETAIL_SUCCESS'
export const GROUP_DETAIL_FAILURE = 'GROUP_DETAIL_FAILURE'

export const GROUP_CREATE = 'GROUP_CREATE'
export const GROUP_CREATE_SUCCESS = 'GROUP_CREATE_SUCCESS'
export const GROUP_CREATE_FAILURE = 'GROUP_CREATE_FAILURE'

export const GROUP_ADD_OBJECT = 'GROUP_ADD_OBJECT'
export const GROUP_ADD_OBJECT_SUCCESS = 'GROUP_ADD_OBJECT_SUCCESS'
export const GROUP_ADD_OBJECT_FAILURE = 'GROUP_ADD_OBJECT_FAILURE'

export const GROUP_REMOVE_OBJECT = 'GROUP_REMOVE_OBJECT'
export const GROUP_REMOVE_OBJECT_SUCCESS = 'GROUP_REMOVE_OBJECT_SUCCESS'
export const GROUP_REMOVE_OBJECT_FAILURE = 'GROUP_REMOVE_OBJECT_FAILURE'

export const GROUP_UPDATE = 'GROUP_UPDATE'
export const GROUP_UPDATE_SUCCESS = 'GROUP_UPDATE_SUCCESS'
export const GROUP_UPDATE_FAILURE = 'GROUP_UPDATE_FAILURE'

export const GROUP_APPROVED_REJECTED = 'GROUP_APPROVED_REJECTED'
export const GROUP_APPROVED_REJECTED_SUCCESS = 'GROUP_APPROVED_REJECTED_SUCCESS'
export const GROUP_APPROVED_REJECTED_FAILURE = 'GROUP_APPROVED_REJECTED_FAILURE'

export const GROUP_EMPTY = 'GROUP_EMPTY'

export const KEYBOARD_DRAWER = 'KEYBOARD_DRAWER'

export const EDIT_ADMIN_GROUP = 'EDIT_ADMIN_GROUP'
export const GET_DEFAULT_PERMISSIONS  ='GET_DEFAULT_PERMISSIONS'
export const GET_DEFAULT_PERMISSIONS_SUCCESS = 'GET_DEFAULT_PERMISSIONS_SUCCESS'
export const GET_DEFAULT_PERMISSIONS_FAILURE  = 'GET_DEFAULT_PERMISSIONS_FAILURE'